import { MimshakDataServiceBase } from "./mimshakDataServiceBase";
import { MimshakData } from "../interfaces/DTO/mimshakData";
import apiClient from "../core/apiClient";

export class MimshakDataService extends MimshakDataServiceBase {
  constructor(apiUrl: string = "/mimshak_data") {
    super(apiUrl);
  }

  async upsertMimshakData(mimshakData: MimshakData): Promise<MimshakData> {
    const response = await apiClient.patch<MimshakData>(`${this.API_URL}/upsert`, mimshakData);
    return response.data;
  }
}

export const mimshakDataService = new MimshakDataService();
